import RequestStatus from '../model/RequestStatus';
import { ProductMatchResponse } from '../model/ProductMatch';

export const PRODUCT_DATA_QUERY_START = 'PRODUCT_DATA_QUERY_START';
export const PRODUCT_DATA_QUERY_SUCCESS = 'PRODUCT_DATA_QUERY_SUCCESS';
export const PRODUCT_DATA_QUERY_FAILED = 'PRODUCT_DATA_QUERY_FAILED';

export interface ProductDataQueryStartAction {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly countryCode: string;
  readonly searchKey: string;
  readonly itemPriceFromUrl?: number;
  readonly shippingCostFromUrl?: number;
}

export const setProductDataQueryStart = (
  countryCode: string,
  searchKey: string,
  itemPriceFromUrl?: number,
  shippingCostFromUrl?: number,
): ProductDataQueryStartAction => ({
  type: PRODUCT_DATA_QUERY_START,
  requestStatus: RequestStatus.LOADING,
  countryCode,
  searchKey,
  itemPriceFromUrl,
  shippingCostFromUrl,
});

export interface GetProductDataQueryComplete {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly productData: any;
}

export const getProductDataQuerySuccessAction = (
  response: ProductMatchResponse,
): GetProductDataQueryComplete => ({
  type: PRODUCT_DATA_QUERY_SUCCESS,
  requestStatus: RequestStatus.SUCCESS,
  productData: response,
});

export const getProductDataQueryFailedAction =
  (): GetProductDataQueryComplete => ({
    type: PRODUCT_DATA_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    productData: null,
  });
